import { ROUTER_PATH } from "@/src/config";
import { ShellLink } from "../../ShellNavigation/ShellAwareLink";
import { getDisplayPlanName } from "../shared/planDisplayUtils";
import { cn } from "utils";
import { useCallback } from "react";
import log from "logbeacon";
import { MemberPlanInfo, useIsPc } from "@/src/hooks";
import { openManageBillingModal } from "./ManageBillingModal";
import { useParams } from "next/navigation";

export const ManageBillingUpgrade = ({
  isFree,
  toMemberPrice,
  data,
}: {
  isFree: boolean;
  toMemberPrice: () => void;
  data?: MemberPlanInfo;
}) => {
  const [isPc] = useIsPc();
  const { locale } = useParams<{ locale: string }>();
  // 处理"管理支付方式"点击：使用 EdgenModalCreateAble 打开账单管理弹窗
  const handleManageBilling = useCallback(() => {
    log.info("[Member][trace] handle Manage Billing open");
    if (isPc) {
      openManageBillingModal();
    }
  }, [isPc]);

  if (isFree) {
    return (
      <button
        type="button"
        className={cn(
          "button primary_button button_m shrink-0",
          isPc ? "xs_button" : "md_button",
        )}
        onClick={toMemberPrice}
      >
        {"Upgrade"}
      </button>
    );
  }
  return (
    <>
      {isPc ? (
        <button
          type="button"
          className={"button xs_button button_m shrink-0 secondary_button"}
          onClick={handleManageBilling}
        >
          {"Manage Billing"}
        </button>
      ) : (
        <ShellLink
          prefetch
          href={`/${locale}${ROUTER_PATH.MEMBER_SUBSCRIPTION}?productName=${getDisplayPlanName(data?.level)}`}
          data-openreplay-label="CurrentPlan · Manage Billing → subscription"
          className="button xs_button button_m shrink-0 border-none"
        >
          {"Manage Billing"}
        </ShellLink>
      )}
    </>
  );
};
